<div class="date-picker-wrapper {{ customClass }}">
  <mat-form-field
    appearance="outline"
    [floatLabel]="'auto'"
    [ngClass]="getWidthClass()"
  >
    <input
      matInput
      #selectedDate="ngModel"
      class="input"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [required]="required"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [maxLength]="10"
      [readonly]="readOnly"
      [(ngModel)]="date"
      (ngModelChange)="onModelChange($event)"
    />
    <mat-datepicker-toggle
      [attr.matIconPrefix]="!isSuffixIcon"
      [attr.matIconSufix]="isSuffixIcon"
      [for]="picker"
    >
      <img
        matDatepickerToggleIcon
        alt="picker"
        [src]="disabled ? disabledIcon : icon"
      />
    </mat-datepicker-toggle>
    <mat-datepicker #picker panelClass="date-picker-popup"></mat-datepicker>
  </mat-form-field>
</div>
